// packages block
import { FormControl, FormHelperText, InputLabel, Tooltip } from '@mui/material'
import { red } from '@mui/material/colors'
import { FC, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import PhoneInput from 'react-phone-input-2'
import { useLocation } from 'react-router-dom'
// styles, constants, utils and interfaces block
import { CustomControlProps } from '../../interfaceTypes'
import { CustomPhoneContainer } from '../../theme/styleComponents'
import { customPhoneControllerStyle } from '../../theme/styleConstants'
import { formatPhoneHyphenated } from '../../utils'

const CustomPhoneController: FC<CustomControlProps> = ({ controllerName, controllerLabel, tooltip }): JSX.Element => {
  const [isBorder, setIsBorder] = useState<boolean>(false)
  const [focus, setFocus] = useState<boolean>(false)
  const { control, getValues } = useFormContext()
  const { pathname } = useLocation()

  useEffect(() => {
    const phone = getValues(controllerName)

    if (
      (pathname.includes('create-case') ||
        pathname === '/profile' ||
        pathname.includes('contacts') ||
        pathname.includes('matters/matter-detail/') ||
        pathname.includes('vendor') ||
        pathname.includes('profit-center')) &&
      typeof phone !== 'undefined'
    ) {
      setFocus(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, getValues])

  return (
    <CustomPhoneContainer focusBorder={isBorder}>
      <Controller
        name={controllerName}
        control={control}
        render={({ field: { value, onChange }, fieldState: { invalid, error: { message } = {} } }) => {
          setIsBorder(!!message)

          const displayValue = formatPhoneHyphenated(value ?? '')

          return (
            <Tooltip title={tooltip || undefined} arrow>
              <FormControl variant="outlined" fullWidth error={invalid}>
                <InputLabel shrink={focus} id={`phone-${controllerName}`}>
                  {controllerLabel}
                </InputLabel>

                <PhoneInput
                  country="us"
                  onlyCountries={['us']}
                  disableCountryCode
                  autoFormat={true}
                  value={displayValue}
                  onChange={phone => onChange(formatPhoneHyphenated(phone))}
                  dropdownClass={!focus ? 'display_none' : undefined}
                  onFocus={() => setFocus(true)}
                  onBlur={() => (value?.length === 0 || !value) && setFocus(false)}
                  placeholder=""
                  inputClass={!focus ? 'transparent' : 'appearance'}
                  masks={{ us: '...-...-....' }}
                  inputStyle={{
                    ...customPhoneControllerStyle,
                    border: focus
                      ? `1px solid rgba(0, 0, 0, 0.2)`
                      : message && focus
                      ? `2px solid ${red[700]}`
                      : `1px solid rgba(0, 0, 0, 0.2)`
                  }}
                />
                {invalid && message && <FormHelperText color="error">{message}</FormHelperText>}
              </FormControl>
            </Tooltip>
          )
        }}
      />
    </CustomPhoneContainer>
  )
}

export default CustomPhoneController
